import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "pwa_admin_token";
const EXP_KEY = "pwa_admin_token_exp";

export const getToken = () => {
  const t = localStorage.getItem(TOKEN_KEY);
  const exp = localStorage.getItem(EXP_KEY);
  if (!t || !exp) return null;
  if (new Date(exp).getTime() < Date.now()) {
    clearToken();
    return null;
  }
  return t;
};

export const setToken = (token, expiresAt) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXP_KEY, expiresAt);
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXP_KEY);
};

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      clearToken();
    }
    return Promise.reject(err);
  }
);

export const STATUS_OPTIONS = [
  { value: "new", label: "New", color: "bg-[#C19A6B] text-[#1A1A1A]" },
  { value: "contacted", label: "Contacted", color: "bg-[#5C4033] text-[#FAF9F6]" },
  { value: "quote_sent", label: "Quote Sent", color: "bg-[#6B7A55] text-[#FAF9F6]" },
  { value: "booked", label: "Booked", color: "bg-[#2E5F4E] text-[#FAF9F6]" },
  { value: "completed", label: "Completed", color: "bg-[#1A1A1A] text-[#D9B27F]" },
  { value: "lost", label: "Lost", color: "bg-[#8B3A3A] text-[#FAF9F6]" },
];

export const statusMeta = (v) => STATUS_OPTIONS.find((s) => s.value === v) || STATUS_OPTIONS[0];

export const login = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token, data.expires_at);
  return data;
};
